export default __webpack_public_path__ + "static/media/reddit-logo.5d30bc01.png";